<template>
  <div class="ts-border ts-border-gray-300 ts-rounded-lg ts-p-3">
    <form class="form-horizontal">
      <div class="overflow-auto ts-max-h-40" style="min-height: 400px">
        <div class="table-ui-detail">
          <table class="ts-w-full">
            <thead>
              <tr>
                <th style="width: 2%">
                  {{ $t("no") }}
                </th>
                <th style="width: 8%">
                  {{ $t("serviceQuotation.barcode") }}
                </th>
                <th style="width: 13%">
                  {{ $t("serviceQuotation.productName") }}
                </th>
                <th style="width: 7%">
                  {{ $t("serviceQuotation.chargeStatus") }}
                </th>
                <!-- <th style="width: 7%">
                  {{ $t("serviceQuotation.chargeReason") }}
                </th> -->
                <th class="ts-text-center" style="width: 7%">
                  {{ $t("serviceQuotation.uom") }}
                </th>
                <th class="ts-text-center" style="width: 8%">
                  {{ $t("serviceQuotation.qty") }}
                </th>
                <th class="ts-text-center" style="width: 8%">
                  {{ $t("serviceQuotation.unitPrice") }}
                </th>
                <th class="ts-text-center" style="width: 8%">
                  {{ $t("serviceQuotation.discountRate") }}
                </th>
                <th class="ts-text-center" style="width: 8%">
                  {{ $t("serviceQuotation.discountType") }}
                </th>
                <th class="ts-text-center" style="width: 8%">
                  {{ $t("serviceQuotation.vatRate") }}
                </th>
                <th class="ts-text-center" style="width: 8%">
                  {{ $t("serviceQuotation.vatAmount") }}
                </th>
                <th class="ts-text-center" style="width: 8%">
                  {{ $t("serviceQuotation.amount") }}
                </th>
                <th class="ts-text-center" style="width: 2%">
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="model.details == 0">
                <td colspan="13" class="ts-text-center ts-p-3 ts-space-x-1">
                  <i class="fa fa-folder-open ts-text-gray-200"></i>
                  <label class="ts-text-gray-400">
                    {{ $t('noData') }}
                  </label>
                  <div class="validate ts-text-left" v-if="errors.has('product_list')">
                    {{ errors.first('product_list') }}
                  </div>
                </td>
              </tr>
              <tr v-for="(item, index) in model.details" :key="index">
                <td>
                  <input type="text" :value="index + 1" class="ts-w-full ts-outline-none ts-text-center" readonly />
                </td>
                <td class="ts-overflow-hidden ts-whitespace-no-wrap">
                  {{ item.barcode }}
                </td>
                <td class="ts-overflow-hidden ts-whitespace-no-wrap">
                  {{ item.product_name_en }}
                </td>
                <td class="ts-overflow-hidden ts-whitespace-no-wrap">
                  <a-select v-model="item.charge_status" :options="chargeStatus" class="ts-w-full"
                    @change="onChangeChargeStatus(item)"></a-select>
                </td>
                <!-- <td class="ts-overflow-hidden ts-whitespace-no-wrap">
                  <a-select v-model="item.charge_reason" :options="chargeStatus" class="ts-w-full"></a-select>
                </td> -->
                <td class="ts-overflow-hidden ts-whitespace-no-wrap ts-text-center">
                  <a-select v-model="item.uom_id" :options="getUom(item.uom_cat_id)" option-filter-prop="children"
                    class="ts-w-full" placeholder="Select" @change="onUomChange(item)"></a-select>
                </td>
                <td>
                  <input type="number" v-model.number="item.quantity" class="form-control ts-text-center" :class="{
                    'is-invalid': errors.has(
                      'product_list.' +
                      index +
                      '.quantity'
                    )
                  }" placeholder="Qty" />
                </td>
                <td>
                  <ts-currency-input v-model="item.unit_price" class="form-control ts-text-right"
                    style="min-width: 120px" :currency="'$'" :precision="2" />
                </td>
                <td>
                  <input type="number" v-model.number="item.discount_rate" class="form-control ts-text-right" :class="{
                    'is-invalid': errors.has(
                      'product_list.' +
                      index +
                      '.quantity'
                    )
                  }" placeholder="Qty" />
                </td>
                <td>
                  <a-select v-model="item.discount_type" class="ts-w-full ts-text-center" style="min-width: 50px"
                    :class="{
                      'is-invalid': errors.has(
                        'po_detail.' + index + '.discount_type'
                      )
                    }">
                    <a-select-option value="%">%</a-select-option>
                    <a-select-option value="$">$</a-select-option>
                  </a-select>
                </td>
                <td>
                  <input type="number" v-model.number="item.vat_rate" class="form-control ts-text-right" :class="{
                    'is-invalid': errors.has(
                      'product_list.' +
                      index +
                      '.quantity'
                    )
                  }" placeholder="Qty" />
                </td>
                <td>
                  <ts-currency-input v-model="item.vat_amount" class="form-control ts-text-right"
                    style="min-width: 120px" disabled :currency="'$'" :precision="2" />
                </td>
                <td>
                  <ts-currency-input v-model="item.total" class="form-control ts-text-right" style="min-width: 120px"
                    disabled :currency="'$'" :precision="2" />
                </td>
                <td class="ts-text-center">
                  <a href="#" class="text-danger" @click.prevent="removeItem(item)">
                    <i class="fa fa-trash"></i>
                  </a>
                </td>
              </tr>
              <tr>
                <td colspan="13">
                  <a-button type="primary" size="small" @click="addNewItem">
                    <i class="fas fa-plus ts-text-xs ts-pr-1"></i>
                    {{ $t('addItem') }}
                  </a-button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr style="background-color: #e3e8f1;">
                <td class="ts-whitespace-no-wrap" colspan="10">
                  <b>{{ $t('serviceQuotation.row') }} :
                    {{ model.details.length }}</b>
                </td>
                <td class="ts-text-right">
                  <b>{{ $t('serviceQuotation.subTotal') }} :</b>
                </td>
                <td>
                  <ts-currency-input v-model.number="model.sub_total" class="form-control ts-text-right"
                    style="min-width: 100px;height:24px;border:transparent;" :currency="'$'" :precision="4" disabled />
                </td>
                <td></td>
              </tr>
              <tr>
                <td colspan="10" rowspan="3" style="border-left-color: transparent !important;
                  border-bottom-color: transparent !important;padding-left: 0;vertical-align: top;">
                  <div class="ts-mt-2">
                    <label class="ts-mb-0">
                      {{ $t('serviceTicket.remarks') }}
                    </label>
                    <textarea v-model="model.remarks" rows="4" class="form-control"
                      style="width: 40%;height: 75px !important;" :class="{
                        'is-invalid': errors.has('remarks')
                      }" />
                    <div class="validate" v-if="errors.has('remarks')">
                      {{ errors.first('remarks') }}
                    </div>
                  </div>
                </td>
                <td class="ts-text-right">
                  <b>{{ $t('serviceQuotation.discountRate') }} :</b>
                </td>
                <td>
                  <input type="number" v-model.number="model.discount_rate" class="form-control" :class="{
                    'is-invalid': errors.has('discount_rate')
                  }" placeholder="Discount_rate" />
                </td>
                <td></td>
              </tr>
              <tr>
                <!-- <td colspan="9"></td> -->
                <td class="ts-text-right">
                  <b>{{ $t('serviceQuotation.discountType') }} :</b>
                </td>
                <td>
                  <a-select v-model="model.discount_type" class="ts-w-full" style="min-width: 50px" :class="{
                    'is-invalid': errors.has('discount_type')
                  }">
                    <a-select-option value="%">%</a-select-option>
                    <a-select-option value="$">$</a-select-option>
                  </a-select>
                </td>
                <td></td>
              </tr>
              <tr>
                <!-- <td colspan="9"></td> -->
                <td class="ts-text-right">
                  <b>{{ $t('serviceQuotation.grandTotal') }} :</b>
                </td>
                <td>
                  <ts-currency-input v-model.number="model.grand_total" class="form-control ts-text-right"
                    style="min-width: 100px;height:24px;border:transparent;" :currency="'$'" :precision="4" disabled />
                </td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </form>
    <!-- form-action -->
    <a-modal v-if="show_form" v-model="show_form" :footer="null" width="50%"
      :title="$t('serviceQuotation.quotationStatus')">
      <ProductList v-model="model" />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Errors } from "form-backend-validation";
import { round, sumBy } from "lodash";
import { clone } from "lodash";
import ProductList from "./product-list.vue";

export default {
  name: "detail",
  props: ["value", "validate"],
  components: {
    ProductList,
  },
  data() {
    return {
      errors: new Errors(),
      show_form: false,
      model: {},
      newItem: {
        barcode: null,
        currency_id: 1,
        discount_amount: 0,
        discount_rate: 0,
        discount_type: "%",
        fx_rate: 1,
        fx_rate_ratio: 1,
        input_currency_id: 1,
        main_product_id: null,
        product_id: null,
        product_name_en: null,
        quantity: 1,
        repair_product_detail_id: null,
        repair_product_id: null,
        serial_no: null,
        sub_total: 0,
        total: 0,
        total_after_discount: 0,
        unit_price: 0,
        uom_id: 1,
        uom_name_en: null,
        vat_amount: 0,
        vat_rate: 0,
      }
    };
  },
  computed: {
    ...mapState("customerService/serviceQuotation", ["edit_data", "formViewDatas"]),
    systemSetting() {
      if (this.formViewDatas['systemSetting']) {
        return this.formViewDatas['systemSetting']
      }
      return null
    },
    chargeStatus() {
      return [
        {
          value: 'pending',
          label: 'Pending'
        },
        {
          value: 'charged',
          label: 'Charged'
        },
        {
          value: 'free',
          label: 'Free'
        },
      ];
    },
    uom() {
      if (this.formViewDatas['uom']) {
        return this.formViewDatas['uom'].map(el => ({
          value: el.uom_id,
          label: el.uom_name_en,
          uom_cat_id: el.uom_cat_id,
          is_default: el.is_default,
          stockout_quantity: el.stockout_quantity
        }))
      }
      return []
    }
  },
  created() {
    this.model = this.value;
  },
  methods: {
    addNewItem() {
      this.show_form = true;
    },
    getUom(uom_cat_id) {
      return this.uom.filter(el => el.uom_cat_id == uom_cat_id)
    },
    onChangeChargeStatus(item) {
      if (item.charge_status == 'free') {
        item.discount_rate = 100
      } else {
        item.discount_rate = 0
      }
    },
    onUomChange(product) {
      const price = product.sale_code.find(el => el.uom_id == product.uom_id)
      product.unit_price = price ? price.unit_price : 0
      product.input_currency_id = product.currency_id
    },
    removeItem(item) {
      this.model.details.splice(
        this.model.details.indexOf(item),
        1
      );
    },
    calculate() {
      if (this.model.details.length > 0) {
        this.model.sub_total = 0;
        this.model.grand_total = 0;
        this.model.details.map(el => {
          el.sub_total = el.quantity * el.unit_price;

          el.discount_amount = round(
            el.discount_type == "%"
              ? (el.sub_total * el.discount_rate) / 100
              : el.discount_rate,
            2
          );

          el.total_after_discount = el.sub_total - el.discount_amount;
          el.vat_amount = (el.total_after_discount * el.vat_rate) / 100;
          el.total = el.total_after_discount + el.vat_amount;
        })

        this.model.sub_total = sumBy(this.model.details, 'total');
        this.model.discount_amount = round(
          this.model.discount_type == "%"
            ? (this.model.sub_total * this.model.discount_rate) / 100
            : this.model.discount_rate,
          2
        );
        this.model.grand_total = this.model.sub_total - this.model.discount_amount;

        if (this.model.details.every(item => item.charge_status === 'free')) {
          this.model.charge_status = 'free'
        } else if (this.model.details.some(item => item.charge_status === 'charged')) {
          this.model.charge_status = 'charged'
        }

      }
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors);
    },
    'model.details': {
      handler() {
        this.calculate()
      },
      deep: true
    },
  }
};
</script>
<style scoped>
.form-control {
  height: 32px !important;
}

.form-control[readonly] {
  background-color: #fff;
  opacity: 1;
}
</style>
<style>
.ant-input-group-addon .ant-select .ant-select-selection {
  margin: 0;
}
</style>